import React from 'react'

export const AnalysisRequestLastUpdate = ({ date = 'No existe fecha', client = 'No existe cliente' }) => {

    if (client === null || client === ' ') { client = 'No existe cliente' }
    if (date === null || date === ' ') { date = 'No existe fecha' }

    return (
        <>
            <div className='d-flex align-items-center w-100'>
                <label className='text-info me-2'>Última Actualización:</label>
                <label> { client } / { date } </label>
            </div>
        </>
    )
}
